module.exports = __webpack_public_path__ + "img/kr-product-ecmy-card2-img3.c386b0b.png";